var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer-page"},[_c('div',{staticClass:"sub-section"},[_c('div',{staticClass:"warpper"},[_c('div',{staticClass:"sub-info"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.list.articleContent)}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }